import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'app-launch-icon-button',
  styleUrl: 'icon-button.css',
  shadow: true,
})
export class IconButton {
  @Prop() type: 'primary' | 'primary ghost' | 'secondary' | 'secondary ghost' | 'tertiary' | 'tertiary ghost' = 'primary';
  @Prop() size: 'small' | 'medium' | 'big' = 'medium';
  @Prop() icon!: string;
  @Prop() accessibleName!: string;

  render() {
    return (
      <button id="button" class={`${this.type} ${this.size}`} aria-label={this.accessibleName}>
        <i id="icon" innerHTML={this.icon}></i>
      </button>
    );
  }
}
